import React from 'react';
import { Route } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

interface FadeRouteProps {
  exact?: boolean;
  path: string;
}

export const FadeRoute: React.FC<FadeRouteProps> = ({ exact, path, children }) => {
  return (
    <Route exact={exact} path={path}>
      {({ match }) => (
        <CSSTransition in={!!match} timeout={300} classNames="fade-container" unmountOnExit={true}>
          <div className="fade-container">{children}</div>
        </CSSTransition>
      )}
    </Route>
  );
};
